// @flow @jsx h

import { h } from 'preact'
import styles from './Box.css'
import { bem } from '@nrk/dh-utils'

type Props = {
  children: any,
  appearLate?: boolean
}

const Box = (props: Props) => {
  return <div class={bem(styles.box, { 'appear-late': props.appearLate })}>{props.children}</div>
}

export { Box }



// WEBPACK FOOTER //
// ./src/v1/components/Foreground/common/Box.js